import { LocalizationProvider, MobileDateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { DatePicker } from 'rsuite';
import { CommonAlert, CoreButton, CoreInputBox, CoreTextArea, Select2DropDown, TagSelectPicker } from './components';
import { splitArrObjData, splitArrData } from './components/Helper';
import CurrencyInput from 'react-currency-input-field';

function AddServiceForm(props) {
  const {
    appointmentVal,
    ifSingleMultiSpec,
    crpDetails,
    serviceSchemaData,
    estimateCost,
    setEstimateCost,
    onClick,
    setheaderEstimateCostDetail,
    dynamicServiceData,
    setDynamicServiceData,
    serviceDropdown,
    serviceCategoryValue,
    statusValue,
    pid,
    careManagerDropdown,
    doctorDropdown,
    clinicDropdown,
    setSelectedCatObj,
    selectedCatObj,
    adminData,
    disabled,
    selectedCrpType,
    selectedCrpMode,
    selectedCrpPackageName,
    selectedFocusArea,
    selectedCustomerType,
    errors,
    setErrors,
    referralSlip,
    userData,
  } = props;
  const [fieldErrors, setFieldErrors] = useState([]);
  const location = useLocation();

  useEffect(() => {
    setSelectedCatObj(location?.state?.item?.service);
  }, [selectedCatObj]);

  const renderInputDateField = (item, error) => {
    let defaultValue = '';
    if (item?.answer) {
      let date = new Date(item.answer);
      if (date != 'Invalid Date') {
        defaultValue = date;
      }
    }

    return (
      <div style={{ position: 'relative' }}>
        <div>
          <label class='inputlabel'>
            {item.required && <span class='requiredInput'> * </span>}
            {item.label}
          </label>
        </div>
        <DatePicker
          disabledDate={(date) => {
            if (new Date(date) < new Date().setHours(0, 0, 0)) {
              return true;
            } else {
              return false;
            }
          }}
          defaultValue={defaultValue}
          preventOverflow
          format='yyyy-MM-dd'
          placeholder='YYYY-MM-DD'
          onChange={(date) => {
            item.answer = date;
            updateDynamicServiceData({ ...dynamicServiceData });
          }}
          placement='autoVerticalStart'
          calendarDefaultDate={defaultValue || new Date()}
          onOk={(date) => {
            item.answer = date;
            updateDynamicServiceData({ ...dynamicServiceData });
          }}
          onClean={(date) => {
            item.answer = '';
          }}
          style={{ width: '100%', padding: 0, margin: 0 }}
          disabled={disabled}
        />
        {!defaultValue && <div class='inputMsg'>{error}</div>}
      </div>
    );
  };
  const renderSingalSelect = (item, error) => {
    let arrData = splitArrObjData(item.options, '|', 'title');

    return (
      <Select2DropDown
        value={item?.answer}
        data={arrData}
        label={item.label}
        placeholder={item.label}
        valueKey='value'
        labelKey='title'
        getObjData
        retuired={true}
        onSelect={(selectedValue, dataObj) => {
          // Store current values before updating
          const currentPackageName = dynamicServiceData?.crp_package_name;
          const currentFocusArea = dynamicServiceData?.focus_area;
          const currentCustomerType = dynamicServiceData?.patient_type;

          // Update the answer
          item.answer = dataObj.title;

          // Create a new dynamicServiceData object that preserves important values
          const updatedServiceData = {
            ...dynamicServiceData,
            crp_package_name: currentPackageName,
            focus_area: currentFocusArea,
            patient_type: currentCustomerType,
          };

          updateDynamicServiceData(updatedServiceData);
        }}
        showMSG={error}
        disabled={disabled}
      />
    );
  };

  const renderMultiSelectWithAdd = (item, error) => {
    let activeData = splitArrData(item?.answer?.toLowerCase(), '|');
    let arrData = splitArrObjData(item?.options, '|', 'title');
    if (item?.searchData?.length) {
      arrData.push({ title: 'Add : ' + item.searchData });
    }
    return (
      <div className='mb-3 capitalize'>
        <TagSelectPicker
          showMSG={error}
          label={item.label}
          data={arrData}
          style={{ width: '100%' }}
          labelKey='title'
          valueKey='value'
          placeholder={item.label}
          onSelect={(val, titleArray) => {
            item.answer = val.join('|');
            updateDynamicServiceData({ ...dynamicServiceData });
          }}
          // onSearch={(data) => checkOptionExit(data, item)}
          msgStyle={{ color: 'red' }}
          value={activeData}
          disabled={disabled}
        />
      </div>
    );
  };

  const renderDateTimeField = (item, error) => {
    const itemAnswer = item.answer ? dayjs(item.answer) : null;
    const previousDate = itemAnswer ? itemAnswer.subtract(1, 'day') : null;

    return (
      <div className='w-100 '>
        <label className='mb-1'>
          <span class='requiredInput'> * </span>
          {item.label}
        </label>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <MobileDateTimePicker
            renderInput={(props) => <TextField {...props} />}
            disablePast={
              !(
                item?.previous_date_allow &&
                (adminData?.role === 'super_admin' ||
                  adminData.role === 'admin' ||
                  adminData?.role === 'revenue_manager' ||
                  adminData?.role === 'health_coach_lead' ||
                  adminData?.role === 'doctor')
              )
            }
            value={item.answer ? dayjs(item.answer) : null}
            shouldDisableDate={(day) => pid && day.isBefore(itemAnswer, 'day')}
            shouldDisableMonth={(day) => pid && day.isBefore(itemAnswer, 'month')}
            shouldDisableYear={(day) => pid && day.isBefore(itemAnswer, 'year')}
            // minDateTime={pid ? dayjs(item.answer) : null}
            placeholder={item.label}
            onAccept={(date) => {
              if (!item?.changed) {
                item.changed = item.answer;
              }
              item.answer = date;

              updateDynamicServiceData({ ...dynamicServiceData });
            }}
            format='DD/MM/YYYY hh:mm A'
            className='MobileDatePickerinputCommon'
            disabled={disabled}
          />
        </LocalizationProvider>
        {<div className='inputMsg'>{error}</div>}
      </div>
    );
  };

  const renderMultiSelect = (item, error) => {
    let activeData = splitArrData(item?.answer?.toLowerCase(), '|');
    let arrData = splitArrObjData(item?.options, '|', 'title');
    return (
      <div className='mb-3 capitalize'>
        <TagSelectPicker
          showMSG={error}
          label={item.label}
          data={arrData}
          style={{ width: '100%' }}
          labelKey='title'
          valueKey='value'
          placeholder={item.label}
          onSelect={(val, titleArray) => {
            item.answer = titleArray.join('|');
            updateDynamicServiceData({ ...dynamicServiceData });
          }}
          msgStyle={{ color: 'red' }}
          value={activeData}
          disabled={disabled}
        />
      </div>
    );
  };

  const renderTextArea = (item, error) => {
    return (
      <CoreTextArea
        disabled={item.name == 'primary_diagnosis' || disabled}
        showMSG={error}
        labelStyle={{
          margin: '0 0 8px 0px',
          fontWeight: 'var(--lightWeight)',
        }}
        rows={2}
        label={item.label}
        value={item.answer || ''}
        retuired={item?.required}
        setValue={(data) => {
          item.answer = data;
          updateDynamicServiceData({ ...dynamicServiceData });
        }}
      />
    );
  };

  const renderInputBox = (item, error) => {
    return (
      <CoreInputBox
        validateNumbers={item.type == 'number'}
        validatedecimal={item.type == 'float'}
        retuired={item?.required}
        labelStyle={{ fontWeight: 'var(--lightWeight)' }}
        label={item.label}
        value={item.answer || ''}
        showMSG={error}
        setValue={(data) => {
          item.answer = data;
          updateDynamicServiceData({ ...dynamicServiceData });
        }}
        disabled={disabled}
      />
    );
  };

  const renderFields = (item, error) => {
    if (item.type == 'date') {
      return renderInputDateField(item, error);
    } else if (item.type == 'single_select') {
      return renderSingalSelect(item, error);
    } else if (
      item.type == 'multi_select' &&
      (item.name == 'diagnosis' || item.name == 'co_morbidities' || item.name == 'allergies' || item.name == 'investigations')
    ) {
      return renderMultiSelectWithAdd(item, error);
    } else if (item.type == 'multi_select') {
      return renderMultiSelect(item, error);
    } else if (item.type == 'date_time') {
      //return null
      return dynamicServiceData?.title == 'crp' ? renderDateTimeField(item, error) : renderDateTimeField(item, error);
      // return dynamicServiceData?.title == 'crp' ? null : renderDateTimeField(item, error);
    } else if (item.type == 'text') {
      return renderTextArea(item, error);
    } else {
      return renderInputBox(item, error);
    }
  };
  const renderDataFields = () => {
    let renderData = () => {
      return serviceSchemaData?.service_schema?.map((item, index) => {
        let fieldError = '';
        if (fieldErrors[index]) {
          fieldError = fieldErrors[index].answer;
        }
        return (
          <div key={index} className='w-100 mb-3'>
            {renderFields(item, fieldError)}
          </div>
        );
      });
    };
    return <>{renderData()}</>;
  };

  const checkrequired = (data) => {
    let isErrors = false;
    let errors = [];

    data?.map((item) => {
      if (item.required) {
        if (item.answer) {
          if (typeof item.answer == 'string' && item.answer.trim().length == 0) {
            errors.push({ answer: 'This field is required' });
            isErrors = true;
          } else {
            errors.push({});
          }
        } else {
          errors.push({ answer: 'This field is required' });
          isErrors = true;
        }
      } else {
        errors.push({});
      }
    });

    // Validate referral slip if Government insurance is selected
    if (selectedCustomerType === 'Govt-Insurance' && !referralSlip && !dynamicServiceData?.referral_slip) {
      errors.push({ referralSlip: 'Referral slip is required for Government insurance.' });
      isErrors = true;
    }

    return { isErrors, errors };
  };

  // Create a helper function to preserve CRP values when updating dynamicServiceData
  const updateDynamicServiceData = (updatedData) => {
    // Preserve CRP-specific values
    const updatedServiceData = {
      ...updatedData,
      crp_package_name: selectedCrpPackageName || dynamicServiceData?.crp_package_name,
      focus_area: selectedFocusArea || dynamicServiceData?.focus_area,
      patient_type: selectedCustomerType || dynamicServiceData?.patient_type,
    };

    setDynamicServiceData(updatedServiceData);
  };

  const handleClick = () => {
    // Call validateFields from props
    if (!props.validateFields()) {
      console.log('Validation failed');
      return; // Stop submission if validation fails
    }
    console.log('Validation passed');
    const formData = new FormData();
    const finalCrpDetail = crpDetails || dynamicServiceData?.crpDetails;
    const filteredCrpDetails =
      finalCrpDetail?.map(({ crp_type, session_booked, session_delivered, location, care_manager, care_manager_list, doctor, doctor_list, price }) => ({
        crp_type,
        session_booked: String(session_booked),
        session_delivered: String(session_delivered),
        location,
        care_manager,
        care_manager_list: care_manager_list || [],
        doctor,
        doctor_list: doctor_list || [],
        price: String(price),
      })) || [];

    console.log('filteredCrpDetails: ', filteredCrpDetails);
    console.log('finalCrpDetail: ', finalCrpDetail);

    // Append all non-file data
    formData.append('crp_details', JSON.stringify(filteredCrpDetails));
    formData.append('data', JSON.stringify(serviceSchemaData?.service_schema || {}));
    // formData.append('service_category', serviceCategoryValue || '');
    formData.append('service_categories', serviceCategoryValue || '');
    formData.append('service', serviceDropdown || '');
    formData.append('status', statusValue || '');
    formData.append('doctor', doctorDropdown ? String(parseInt(doctorDropdown, 10)) : '');
    formData.append('care_manager', careManagerDropdown ? String(parseInt(careManagerDropdown, 10)) : '');
    formData.append('location', clinicDropdown ? String(parseInt(clinicDropdown, 10)) : '');
    formData.append('estimated_cost', estimateCost ? String(parseFloat(estimateCost)) : 0);
    formData.append('crp_category', selectedCrpType || dynamicServiceData?.crp_category || '');
    formData.append('crp_mode', selectedCrpMode || dynamicServiceData?.crp_mode || '');
    formData.append('crp_package_name', selectedCrpPackageName || dynamicServiceData?.crp_package_name || '');
    formData.append('focus_area', selectedFocusArea || dynamicServiceData?.focus_area || '');
    formData.append('patient_type', selectedCustomerType || dynamicServiceData?.patient_type || '');
    formData.append('appointment', appointmentVal || '');

    // Append the file (referral_slip) if it exists and is a valid File object
    if (referralSlip instanceof File) {
      formData.append('referral_slip', referralSlip);
    }

    // Validate required fields
    let checkIserror = checkrequired(serviceSchemaData?.service_schema);
    if (checkIserror.isErrors) {
      console.log('Schema validation errors:', checkIserror.errors);
      setFieldErrors(checkIserror.errors);
      return;
    }

    console.log('Form data prepared:', Object.fromEntries(formData));
    // ✅ Send FormData to API
    onClick(formData);
  };

  function formatToIST(utcDateString) {
    // Convert the UTC date string to a Date object
    const utcDate = new Date(utcDateString);

    // Format the date in Indian Standard Time (IST)
    const options = {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };

    // Use toLocaleString to format the date
    const istDateString = utcDate.toLocaleString('en-IN', options).toUpperCase();

    return istDateString;
  }

  return (
    <>
      {serviceDropdown && serviceSchemaData?.service_schema?.length ? (
        <div className=''>
          {renderDataFields()}
          {(dynamicServiceData?.title === 'crp' || dynamicServiceData?.service?.title === 'crp') && (
            <div className='mt-3'>
              {/* <CoreInputBox
                  // disabled={data?.payment_type == 'paid' || appointmentDetail?.payment_type == 'paid' || appointmentDetail?.payment_type == 'free'}
                  // retuired
                  disabled
                  validateNumbers
                  validateZero
                  validatedecimal
                  label={'CRP Booking Date'}
                  placeholder={'CRP Booking Date'}
                  // showMSG={errors?.amount}
                  value={pid ? formatToIST(dynamicServiceData?.created_at) : ''}
                /> */}
            </div>
          )}
          <div className='w-100 mt-4'>
            {/* <CoreInputBox
              maxLength={10}
              disabled={ifSingleMultiSpec}
              onlyNumTwoDigitAfterDecimals
              label='Service Cost'
              placeholder='Service Cost'
              value={estimateCost || null}
              setValue={(data, dataObj) => {
                setheaderEstimateCostDetail(data);
                setEstimateCost(data);
              }}
            /> */}
            {!disabled && (
              <>
                <div className='inputFieldHeader'>
                  <label className='inputlabel' htmlFor='validationCustom01 mt-3 slot-name'>
                    {/* <span style={{ color: 'red' }}>*&nbsp;</span> */}
                    {'Service Cost'}
                  </label>
                </div>
                <CurrencyInput
                  disabled={ifSingleMultiSpec}
                  id='validationCustom01'
                  name='input-1'
                  className={`form-control coreInput`}
                  label='Service Cost'
                  value={estimateCost || 0}
                  // showMSG={errors?.crp_final_bill_amounts?.[crpTypeFinalAmount?.title?.toLowerCase()]}
                  msgStyle={{ color: 'red' }}
                  onValueChange={(data) => {
                    setheaderEstimateCostDetail(data);
                    setEstimateCost(data);
                  }}
                  placeholder={'Service Cost'}
                  prefix={'₹'}
                  step={1}
                />
              </>
            )}
            {/* <p className='capitalize' style={{ color: 'red' }}>
              {errors?.crp_final_bill_amounts?.[crpTypeFinalAmount?.title?.toLowerCase()]}
            </p> */}
          </div>
          {dynamicServiceData?.status && dynamicServiceData?.status == 'done' && !['super_admin', 'admin'].some((role) => userData?.role == role) ? (
            <>
              <br />
              <center>
                <span style={{ color: 'green' }}>You cannot update anything because the service status is 'Done'</span>
              </center>
              <CoreButton
                // onClick={handleClick}
                customClass='btn btn-secondary btn-lg'
                core_remove={true}
                title='Save Details'
              />
            </>
          ) : (
            <>
              {serviceSchemaData?.service_schema?.length && !disabled && (
                <CoreButton onClick={handleClick} customClass='btn btn-secondary btn-lg' title='Save Details' />
              )}
            </>
          )}
        </div>
      ) : null}
    </>
  );
}

export default AddServiceForm;
